import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import OperationsService from "../../../../../services/Production/OperationsService";
import getCurrentUserId from "../../../../../reduxSaga/sagas/requests/currentUserId";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import WorkstationService from "../../../../../services/Production/WorkstationService";
import UploadAndDownloadService from "../../../../../services/uploadAndDownloadFile";

const styles = {
  container: (base) => ({
    ...base,
    flex: 1,
  }),
};
const NewOperation = () => {
  const navigate = useNavigate();
  const animatedComponents = makeAnimated();

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [description, setDescription] = useState("");
  const [name, setName] = useState("");
  const [defaultWorkstationId, setDefaultWorkstationId] = useState(0);
  const [availableWorkstation, setAvailableWorkstation] = useState([]);
  const [selectedOptionWorkstation, setSelectedOptionWorkstation] =
    useState(null);

  const [workstationSelectPlaceHolder, setWorkstationSelectPlaceHolder] =
    useState("Choisir une station de travail");
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [guideFile, setGuideFile] = useState([]);

  useEffect(() => {
    WorkstationService.allWorkstations(getCurrentUserId())
      .then((response) => {
        console.log("response", response);
        if (response.data.success) {
          // setAvailableOperation(response.data.success);
          setAvailableWorkstation([])
          response.data.success.map((element, i) => {
            if (i === 0) {
              setDefaultWorkstationId(element.id);
            }
            setAvailableWorkstation((oldArray) => [
              ...oldArray,
              {
                value: element.id,
                label: element.code + " " + element.name,
              },
            ]);
          });
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : pas de station de travail");
        }
      })
      .catch((e) => {
        console.log("error in getAllRealWarehouse", e);
      });
  }, []);

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };

  const onChangeDescriptionHandler = (event) => {
    setDescription(event.target.value);
  };
  const onChangeNameHandler = (event) => {
    setName(event.target.value);
  };

  const onChangeSelectedWorkstation = (selectedOption) => {
    setSelectedOptionWorkstation();
    setDefaultWorkstationId(selectedOption.value);
  };
  const onValidOperationHandler = () => {
    let operationModel = {
      name: name,
      idUser: getCurrentUserId(),
      descriptions: description,
      defaultWorkstationId: defaultWorkstationId,
      path: "",
    };
    if (guideFile.length !== 0) {
      const uploadData = new FormData();
      uploadData.append("picture", guideFile);

      UploadAndDownloadService.uploadFile(
        "/retail/uploadFile/uploadFile/GuideOperation",
        uploadData
      )
        .then((response) => {
          if (Object.keys(response.data)[0] === "success") {
            operationModel.path = response.data.success;

            OperationsService.addOperation(operationModel)
              .then((response) => {
                if (response.data["success"]) {
                  setOpenSuccessAlert(true);
                  setSuccessAlertText("Enregistrement avec succées");
                  setTimeout(() => {
                    navigate(`/operations`);
                  }, 2000);
                } else {
                  setOpenErrorAlert(true);
                  setErrorAlertText("Erreur :erreur serveur ");
                }
              })
              .catch((e) => {
                console.log("error", e);
              });
          } else {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : il ya un erreur  ");
          }
        })
        .catch(() => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un probléme de connection");
        });
    } else {
      operationModel.path = "any";
      OperationsService.addOperation(operationModel)
        .then((response) => {
          if (response.data["success"]) {
            setOpenSuccessAlert(true);
            setSuccessAlertText("Enregistrement avec succées");
            setTimeout(() => {
              navigate(`/operations`);
            }, 2000);
          } else {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur :erreur serveur ");
          }
        })
        .catch((e) => {
          console.log("error", e);
        });
    }
  };
  const onUploadFileHandler = (e) => {
    console.log("facture name", e.target.files[0]);
    if (e.target.files[0].size > 2097152) {
      setOpenInfoAlert(true);
      setInfoAlertText("la taille du fichier ne doit pas dépasser 2 Mo");
    } else {
      setGuideFile(e.target.files[0]);
    }
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item">Home</li>
                <li class="breadcrumb-item active">Ajouter Opération</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-dark">
                <div className="card-header">
                  <h5 className="card-title"> Ajouter une Opération</h5>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label htmlFor="inputName">Libellé</label>
                        <input
                          placeholder="Ajouter libellé "
                          onChange={onChangeNameHandler}
                          type="text"
                          id="inputName"
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div>
            
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        {" "}
                        <label for="exampleInputFile">
                          Guide de l'opération{" "}
                        </label>
                        <div class="input-group">
                          <div class="custom-file">
                            <input
                              accept="application/pdf, .jpg, .jpeg, .png"
                              type="file"
                              className="custom-file-input"
                              id="exampleInputFile"
                              onChange={onUploadFileHandler}
                            />
                            <label
                              class="custom-file-label"
                              for="exampleInputFile"
                            >
                              Entrer le fichier du guide de l'opération
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label>Choisir une station de travail</label>

                        <Select
                          styles={styles}
                          // isMulti
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          defaultValue={selectedOptionWorkstation}
                          onChange={onChangeSelectedWorkstation}
                          options={availableWorkstation}
                          placeholder={workstationSelectPlaceHolder}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label htmlFor="inputDescription">Description</label>
                        <textarea
                          placeholder="Saisir..."
                          onChange={onChangeDescriptionHandler}
                          id="inputDescription"
                          className="form-control"
                          rows={2}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-footer" style={{ marginTop: "1%" }}>
                  <button
                    class="btn btn-dark float-right"
                    style={{ marginTop: "1%" }}
                    onClick={onValidOperationHandler}
                  >
                    Confirmer
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default NewOperation;
